export interface ImagesInterface {
    src: string,
    alt?: string,
    securl?: string,
    label?: string,
}